import Loader from "../utils/Loader";
import { useState } from 'react';



const VisitorHeader = () => {

    const [isLoading, setLoader] = useState(false);

    return (
        <>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}
            <div className="app-header header sticky">
                <div className="app-header header sticky">
                    <div className="container-fluid main-container">
                        <div className="d-flex">
                            <a className="logo-horizontal " href="index.html">
                                <img
                                    src="../images/itme.png" className="header-brand-img desktop-logo" alt="logo" />
                            </a>
                            <div class="side-header">
                                <a class="header-brand1" >
                                    <img src="../images/itme.png" class="header-brand-img header-brand-img-1 light-logo1" alt="top-left logo" />
                                </a>
                            </div>
                            <p className=" header-logo-name">30<sup>th</sup> NOV - 02<sup>nd</sup> DEC 2023 <br></br> Kenyatta International Convention Centre<br></br> Nairobi, Kenya
                            </p>
                            <p className="header-assistance">
                                For Assistance
                                <br>
                                </br>
                                +91 80108 23774 / +91 98205 07570
                                <br>
                                </br>
                                <a href="mailto:itme@itme-africa.com">itme@itme-africa.com / </a>{" "}
                                <a href="mailto:itme@india-itme.com"> itme@india-itme.com</a>
                            </p>


                            <div class="right-logo">
                                <p className='right-logo-text'>Owned and Organised by</p>
                                <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
                            </div>
                            
                        </div>
                    </div>
                </div>


            </div>
        </>
    )
}

export default VisitorHeader;